;(function () {
  'use strict'

  angular
    .module('contrast.score-settings')
    .factory('ScoreSettingsService', [
      '$q',
      'logger',
      'preferencesService',
      'OrganizationFactory',
      'ErrorService',
      'AvailableLanguagesService',
      'PREFERENCE_PROPERTIES',
      ScoreSettingsService
    ])

  function ScoreSettingsService(
    $q,
    logger,
    preferencesService,
    OrganizationFactory,
    ErrorService,
    AvailableLanguagesService,
    PREFERENCE_PROPERTIES
  ) {
    var service = {
      getInitData: getInitData,
      update: update
    }

    return service

    function getInitData() {
      return $q
        .all({
          overrideEnabled: _getEnableOverridePropertyValue(),
          scorePolicy: _getScorePolicy(),
          availableLanguages: AvailableLanguagesService.get()
        })
        .catch(function (response) {
          ErrorService.processError(response)
          return response
        })
    }

    function _getEnableOverridePropertyValue() {
      return preferencesService.getBooleanValue(
        PREFERENCE_PROPERTIES.OVERRIDE_LIBRARY_SCORING
      )
    }

    function _getScorePolicy() {
      return OrganizationFactory.getScorePolicy().then(function (response) {
        var data = response.data
        return {
          libraryScoreType: data.libraryScoreType,
          failLibrariesPolicy: data.failLibrariesPolicy,
          overallScoreType: data.overallScoreType,
          overallScoreLanguages: _parseOverallScoreLanguages(
            data.overallScoreLanguages
          )
        }
      })
    }

    function _parseOverallScoreLanguages(languages) {
      if (languages && angular.isString(languages)) {
        return languages.split(',')
      }
      return false
    }

    function update(data) {
      return OrganizationFactory.updateScorePolicy(data)
        .then(function (response) {
          var data = response.data
          logger.logSuccess(data.messages[0])
          return data
        })
        .catch(ErrorService.processError)
    }
  }
})()
